import React from 'react';
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaMobileAlt,
} from 'react-icons/fa';

const OfficeLocation = () => {
  return (
    <div className="w-full lg:w-[90%] mx-auto px-4 py-10 font-sans text-gray-800 mb-10">
      {/* Title */}
      <h2 className="text-2xl font-semibold text-center mb-6">Office Location</h2>

      {/* Google Map */}
      <div className="w-full mb-10">
        <iframe
          title="Office Map"
          src="https://www.google.com/maps?q=31.5187454,74.3447275&output=embed"
          className="w-full h-[350px] border-none"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

      {/* Contact Info */}
      <div className="grid md:grid-cols-2 gap-8 mb-10">
        <div>
          <h3 className="text-xl font-semibold mb-4">CONTACT DETAILS</h3>
          <div className="flex items-start gap-4">
                    <FaMapMarkerAlt className="text-gray-600 mt-1" />
                    <p className="text-base font-medium">
                    Office 606, Eden Tower, Gulberg, Lahore, Pakistan.
                    </p>
                  </div>
                  <div className="flex items-start gap-4">
                    <FaPhoneAlt className="text-gray-600 mt-1" />
                    <p className="text-base font-medium">042-35782365</p>
                  </div>
                  <div className="flex items-start gap-4">
                   <p className="flex items-start gap-4">
                        <FaMobileAlt className="text-gray-600 mt-1" />
                        <span className="text-base font-medium">
                           0345-8456449
                        </span>
                      </p>
                  </div>
                  <div className="flex items-start gap-4">
                    <FaEnvelope className="text-gray-600 mt-1" />
                    <p className="text-base font-medium">info@pacificbuilders.com</p>
                  </div>
        </div>
      </div>

      {/* Message Form */}
      <div className="w-full max-w-4xl mx-auto">
        <h3 className="font-semibold text-lg mb-4">SEND US A MESSAGE</h3>
        <form className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <input
              type="text"
              placeholder="Name"
              className="border p-2 w-full"
              required
            />
            <input
              type="email"
              placeholder="Email Address"
              className="border p-2 w-full"
              required
            />
            <input
              type="text"
              placeholder="Subject"
              className="border p-2 w-full"
            />
          </div>
          <textarea
            placeholder="Message"
            className="border p-2 w-full h-40 resize-none"
            required
          ></textarea>
          <button
            type="submit"
            className="bg-gradient-to-b from-[#1BB095] to-teal-900 text-white px-6 py-2 rounded float-right"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default OfficeLocation;
